import React from 'react';
import { useAgencyBranding } from '../../branding';
import { Box, Card, Container, CssBaseline, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { QuotationServiceSimple } from '../../types';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

const useStyles = makeStyles((theme) => ({
	paper: {
		marginTop: theme.spacing(2),
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'left',
	},
	listItem: {
		marginBottom: theme.spacing(1),
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'flex-start',
		fontFamily: theme.typography.fontFamily,
	},
	content: {
		marginTop: '16px',
	},
}));

interface Props {
	services: QuotationServiceSimple[];
	manualServices: QuotationServiceSimple[];
	isExternal?: boolean;
}
export const QuotationServicesObservationPreview = ({ services, manualServices, isExternal }: Props): JSX.Element => {
	const classes = useStyles();
	const branding = useAgencyBranding(isExternal);

	return (
		<Container component="main" maxWidth="md">
			<CssBaseline />
			<div className={classes.paper}>
				<Typography
					component="h1"
					variant="h6"
					sx={{
						marginBottom: '8px',
						width: '100%',
						background: branding.headerGradient,
						paddingLeft: '16px',
						paddingRight: '16px',
						paddingTop: '8px',
						paddingBottom: '8px',
						borderRadius: '10px',
						fontSize: '1rem',
						fontWeight: 700,
						color: 'white',
						boxShadow: '0 8px 20px rgba(49, 25, 75, 0.16)',
					}}
				>
					Observaciones de servicios incluidos:
				</Typography>
				<Card
					sx={{
						p: 1.25,
						borderRadius: '10px',
						border: '1px solid rgba(49, 25, 75, 0.10)',
						boxShadow: '0 6px 18px rgba(49, 25, 75, 0.08)',
					}}
				>
					{services.map((service, index) => (
						<Box
							key={`service-observations-preview-${index}`}
							display="flex"
							gap={1}
							alignItems="flex-start"
							py={0.75}
							borderBottom={
								index + 1 === services.length && manualServices.length === 0
									? 'none'
									: '1px solid rgba(49, 25, 75, 0.07)'
							}
						>
							<InfoOutlinedIcon color="secondary" sx={{ fontSize: 18, mt: 0.1 }} />
							<Box>
								<Typography variant="body2" fontWeight={800} color="primary" lineHeight={1.25}>
									{service.name}
								</Typography>
								<Typography variant="caption" color="text.secondary" lineHeight={1.3} display="block">
									{service.description}
								</Typography>
							</Box>
						</Box>
					))}

					{manualServices.map((manualService, index) => (
						<Box
							key={`manual-service-observations-preview-${index}`}
							display="flex"
							gap={1}
							alignItems="flex-start"
							py={0.75}
							borderBottom={index + 1 === manualServices.length ? 'none' : '1px solid rgba(49, 25, 75, 0.07)'}
						>
							<InfoOutlinedIcon color="secondary" sx={{ fontSize: 18, mt: 0.1 }} />
							<Box>
								<Typography variant="body2" fontWeight={800} color="primary" lineHeight={1.25}>
									{manualService.name}
								</Typography>
								<Typography variant="caption" color="text.secondary" lineHeight={1.3} display="block">
									{manualService.description}
								</Typography>
							</Box>
						</Box>
					))}
				</Card>
			</div>
		</Container>
	);
};
